import { useEffect, useState, useRef } from 'react';
import { Container, Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import MessagingFiltersScreen from './Messages/MessagingFiltersScreen';
import UpdatesRemainder from './Updates&Remainders/UpdatesRemainder';
import './DetailIndexScreen.scss';
import { useLocation } from 'react-router-dom';
import useMyMessage from './Messages/hook/useMyMessage';
import ViewAllDocuments from '../uploaddocument/ViewAllDocuments';
import { ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';

function DetailedPageIndex() {
  const { t } = useTranslation();
  const location = useLocation();
  const [selectedTabLocal, setSelectedTabLocal] = useState('');
  const [messageCount] = useState(location?.state?.notificationCount);
  const [setShowNotification] = useState(location?.state?.setShowNotification);
  const [messageSelectedFromPopup] = useState(location?.state?.popUpMessage);
  const [isComposed, setIsComposed] = useState(false);
  const pageInfo = useRef(null);

  const {
    getSendReceiveMessageList,
    sortByData,
    searchText,
    typeData,
    SortByDummyOptions,
    typeOptionList,
    setSortByData,
    setTypeData,
    AttachmentOptions,
    attachmentData,
    setAttachmentData,
    onSearch,
    resetFilterHandler,
    isComposing,
    setIsComposing,
    replyEnabled,
    setReplyEnabled,
    listApiServerError,
    listApiDataNotFoundError,
    listLoading,
    filteredData,
    totalRecords,
    pageSize,
    currentPage,
    displayPaginationMininumCount,
    pageSizeHandler,
    paginationHandler,
    selectedTab,
    setSelectedTab,
    setSelectedIndex,
    selectedIndex,
    setSelectedIndexForSent,
    selectedIndexForSent,
    messageDetailData,
    setMessageDetailData,
    setCurrentPage,
    getSanitizedContent,
    downloadFileHandler,
    downloadAllFileHandler,
    getSendReceiveMessageDetail,
    messageDetailLoading,
    messageDetailApiServerError,
    messageDetailApiDataNotFoundError,
    recordsPerPage,
    sendNewMessageFormRef,
    sendReplyMessageFormRef,
  } = useMyMessage({
    messageSelectedFromPopup,
    setIsComposed,
    selectedTabLocal,
  });

  const tabClickHandler = (e) => {
    setSelectedTabLocal(e);
    console.log('e :', e);
  };

  const { NotificationResp } = useSelector(
    (state) => state?.messageAndNotification,
  );

  useEffect(() => {
    if (selectedTabLocal === 'messages') {
      getSendReceiveMessageList('messages');
    }
  }, [selectedTabLocal]);

  useEffect(() => {
    if (isComposed) {
      setIsComposing(false);
      setSelectedTabLocal(null);
      setTimeout(() => {
        setSelectedIndexForSent(0);
        setSelectedTabLocal('messages');
      }, 1000);
    }
  }, [isComposed]);

  const getTitle = (title, count) => {
    return (
      <div
        role="button"
        tabIndex={-1}
        aria-label={`${title} ${count} Unread messages`}
      >
        {title}{' '}
        {messageCount && count && (
          <span className="mymessage-count"> {count} </span>
        )}
      </div>
    );
  };

  useEffect(() => {
    console.log('location_State', location?.state);
    setShowNotification && setShowNotification(false);
    if (location?.state?.showmymessage === true) {
      tabClickHandler('messages');
    }
    if (
      location?.state?.showdocuments === true ||
      location?.state?.comingFrom === 'DashboardUploadIcon'
    ) {
      tabClickHandler('document');
    }
    if (location?.state?.shownotification === true) {
      tabClickHandler('notification');
    }
    setTimeout(() => {
      if (pageInfo && pageInfo.current) {
        pageInfo.current.focus();
      }
    }, 10);
  }, [location?.state]);
  return (
    <div id="messagedocument" className="Messaging_and_Documents">
      <Container>
        <div className="document-heading-container">
          <div
            className="sr-only"
            role="heading"
            aria-level={1}
            tabIndex={-1}
            ref={pageInfo}
          >
            Messages and Documents
          </div>
          <h1 className="content-header" aria-hidden={true}>
            <span className="content-header-bold">
              {t('member.messaging.main_title')}
            </span>
          </h1>
        </div>
      </Container>
      <div>
        <Tabs
          activeKey={selectedTabLocal}
          defaultActiveKey="messages"
          id="uncontrolled-tab-example"
          className="mb-3 container pl-3"
          onSelect={tabClickHandler}
        >
          {(selectedTabLocal === 'messages' || true) && (
            <Tab
              eventKey="messages"
              title={getTitle(
                'My Messages',
                NotificationResp?.MessageCount?.Message > 0 &&
                  NotificationResp?.MessageCount?.Message,
              )}
            >
              <MessagingFiltersScreen
                sortByData={sortByData}
                searchText={searchText}
                typeData={typeData}
                SortByDummyOptions={SortByDummyOptions}
                typeOptionList={typeOptionList}
                setSortByData={setSortByData}
                setTypeData={setTypeData}
                AttachmentOptions={AttachmentOptions}
                attachmentData={attachmentData}
                setAttachmentData={setAttachmentData}
                onSearch={onSearch}
                resetFilterHandler={resetFilterHandler}
                isComposing={isComposing}
                setIsComposing={setIsComposing}
                sendNewMessageFormRef={sendNewMessageFormRef}
                sendReplyMessageFormRef={sendReplyMessageFormRef}
                replyEnabled={replyEnabled}
                setReplyEnabled={setReplyEnabled}
                listApiServerError={listApiServerError}
                listApiDataNotFoundError={listApiDataNotFoundError}
                listLoading={listLoading}
                filteredData={filteredData}
                totalRecords={totalRecords}
                pageSize={pageSize}
                currentPage={currentPage}
                displayPaginationMininumCount={displayPaginationMininumCount}
                pageSizeHandler={pageSizeHandler}
                recordsPerPage={recordsPerPage}
                paginationHandler={paginationHandler}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                setSelectedIndex={setSelectedIndex}
                selectedIndex={selectedIndex}
                setSelectedIndexForSent={setSelectedIndexForSent}
                selectedIndexForSent={selectedIndexForSent}
                messageSelectedFromPopup={messageSelectedFromPopup}
                messageDetailData={messageDetailData}
                setMessageDetailData={setMessageDetailData}
                setCurrentPage={setCurrentPage}
                getSanitizedContent={getSanitizedContent}
                downloadFileHandler={downloadFileHandler}
                downloadAllFileHandler={downloadAllFileHandler}
                setIsComposed={setIsComposed}
                getSendReceiveMessageDetail={getSendReceiveMessageDetail}
                messageDetailLoading={messageDetailLoading}
                messageDetailApiServerError={messageDetailApiServerError}
                messageDetailApiDataNotFoundError={
                  messageDetailApiDataNotFoundError
                }
                mainSelectedTab={selectedTabLocal}
              />
            </Tab>
          )}
          {(selectedTabLocal === 'document' || true) && (
            <Tab
              eventKey="document"
              //title={getTitle('Documents', messageCount?.Document)}
              title="Documents"
            >
              <ViewAllDocuments />
            </Tab>
          )}
          {(selectedTabLocal === 'notification' || true) && (
            <Tab
              eventKey="notification"
              title={getTitle(
                'Updates/Reminders',
                NotificationResp?.MessageCount?.Notification > 0 &&
                  NotificationResp?.MessageCount?.Notification,
              )}
            >
              <UpdatesRemainder selectedTabLocal={selectedTabLocal} />
            </Tab>
          )}
        </Tabs>
      </div>
      <div className="toastify">
        <ToastContainer
          draggable
          pauseOnHover
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          autoClose={5000}
          position="top-center"
          newestOnTop={false}
          hideProgressBar={false}
          className="toastcontainer"
        />
      </div>
    </div>
  );
}

export default DetailedPageIndex;
